import { isPast } from "../../../dependencies/utils";
import { isBookingTimeValid, slotSupportsPeople } from "../../../utils/slots";
import type { DiscountAvailabilitySlotType } from "../../types";

export type WalkInAvailabilitySlotStatus =
  "closed" | "sold" | "unavailable" | "available";

export type WalkInSlotAvailabilityProperties = Pick<
  DiscountAvailabilitySlotType,
  | "open"
  | "available"
  | "time"
  | "walkInDinersAvailable"
  | "walkInClaimStart"
  | "walkInClaimEnd"
>;

/**
 * Walk-in counterpart of `getAvailabilitySlotStatus`.
 * Uses {@link walkInDinersAvailable} and claim windows instead of FT
 * `dinersAvailable` / `cutOffTime`. Removable with `model/walkIn`.
 */
export default function getWalkInAvailabilitySlotStatus(
  slot: WalkInSlotAvailabilityProperties,
  people?: number | null,
): WalkInAvailabilitySlotStatus {
  if (slot.open === false) {
    return "closed";
  }

  // Claim window has not opened yet.
  if (slot.walkInClaimStart && !isPast(slot.walkInClaimStart)) {
    return "unavailable";
  }

  // Claim window has closed.
  if (slot.walkInClaimEnd && isPast(slot.walkInClaimEnd)) {
    return "unavailable";
  }

  if (!slot.time || !isBookingTimeValid(slot.time)) {
    return "sold";
  }

  if (
    people &&
    slot.walkInDinersAvailable &&
    slot.walkInDinersAvailable.length > 0
  ) {
    return slotSupportsPeople(slot.walkInDinersAvailable, people)
      ? "available"
      : "unavailable";
  }

  return slot.available ? "available" : "unavailable";
}
